import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTaskListEdit = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "task-list-edit" }),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M8.25,23.261h-6a1.5,1.5,0,0,1-1.5-1.5V2.261a1.5,1.5,0,0,1,1.5-1.5H12.879a1.5,1.5,0,0,1,1.06.439l5.872,5.872a1.5,1.5,0,0,1,.439,1.06v.129"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M12.75.761v6a1.5,1.5,0,0,0,1.5,1.5h6"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M8.169,9.619,6.037,12.461a.75.75,0,0,1-1.13.08L3.75,11.385"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M8.169,16.369,6.037,19.211a.75.75,0,0,1-1.13.08L3.75,18.134"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 11.25,
			y1: 12.761,
			x2: 15,
			y2: 12.761
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M22.631,14.88,15,22.511l-3.75.75.75-3.75,7.631-7.631a2.115,2.115,0,0,1,2.991,0l.009.009A2.115,2.115,0,0,1,22.631,14.88Z"
		})
	]
});
export default SvgTaskListEdit;
